import type { ModelData } from '../../types'

export const dragonVisAVisAku: Record<string, ModelData> = {
  'dragon-aku-4-duo': {
    id: 'dragon-aku-4-duo',
    name: 'DRAGON AKU 4 DUO',
    power: '16 kW',
    type: 'powietrzny-aku nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-aku-4-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 4 DUO',
    description: 'WkĹ‚ad powietrzny dwustronny vis-a-vis AKU 16 kW',
    specialNote: '',
    basePrices: {
      standard: { 
        single: 10330, 
        double: 11830, 
        triple: 13430
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 390,
          'flush-30': 430,
          'recessed-15': 500,
          'recessed-30': 560,
          'recessed-15-45': 630
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 860
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
    },
    
    labels: {
      variant: { 
        'standard': 'Standard'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'PodwĂłjna x2',
        'triple': 'PotrĂłjna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '16 kW',
      glassSize: '711 x 465 mm (obie strony)',
      width: '674 mm',
      height: '955 mm',
      depth: '450 mm',
      weight: '185 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 4 DUO',
      body: 'DzieĹ„ dobry,\n\nProszÄ™ o wycenÄ™ wkĹ‚adu kominkowego DRAGON AKU 4 DUO w konfiguracji:\n\nModel: DRAGON AKU 4 DUO\nMoc: 16 kW\nKonfiguracjÄ…: [KONFIGURACJA]\nCena: [CENA] zĹ‚ netto\n\nUwaga: \n\nPozdrawiam'
    }
  },

  'dragon-aku-8-duo': {
    id: 'dragon-aku-8-duo',
    name: 'DRAGON AKU 8 DUO',
    power: '22 kW',
    type: 'powietrzny-aku nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-aku-8-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 8 DUO',
    description: 'WkĹ‚ad powietrzny dwustronny vis-a-vis AKU 22 kW',
    specialNote: 'DostÄ™pny jedynie w wersji AKU. Do wkĹ‚adĂłw doĹ‚Ä…czany jest stelaĹĽ na MODUĹY akumulacyjne.',
    basePrices: {
      standard: { 
        single: 14800, 
        double: 16700, 
        triple: 18740
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 300,
          'flush-30': 350,
          'recessed-15': 390,
          'recessed-30': 440,
          'recessed-15-45': 490
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'PodwĂłjna x2',
        'triple': 'PotrĂłjna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '22 kW',
      glassSize: '1083 x 510 mm (obie strony)',
      width: '1110 mm',
      height: '755 mm',
      depth: '450 mm',
      weight: '215 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 8 DUO',
      body: 'DzieĹ„ dobry,\n\nProszÄ™ o wycenÄ™ wkĹ‚adu kominkowego DRAGON AKU 8 DUO w konfiguracji:\n\nModel: DRAGON AKU 8 DUO\nMoc: 22 kW\nKonfiguracjÄ…: [KONFIGURACJA]\nCena: [CENA] zĹ‚ netto\n\nUwaga: \n\nPozdrawiam'
    }
  },

  'dragon-aku-9-duo': {
    id: 'dragon-aku-9-duo',
    name: 'DRAGON AKU 9 DUO',
    power: '25 kW',
    type: 'powietrzny-aku nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-aku-9-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 9 DUO',
    description: 'WkĹ‚ad powietrzny dwustronny vis-a-vis AKU 25 kW',
    specialNote: '',
    basePrices: {
      standard: { 
        single: 12040, 
        double: 13970, 
        triple: 16320
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 420,
          'flush-30': 500,
          'recessed-15': 610,
          'recessed-30': 700,
          'recessed-15-45': 750
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 860
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'PodwĂłjna x2',
        'triple': 'PotrĂłjna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '25 kW',
      glassSize: '1371 x 510 mm (obie strony)',
      width: '1398 mm',
      height: '755 mm',
      depth: '450 mm',
      weight: '245 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 9 DUO',
      body: 'DzieĹ„ dobry,\n\nProszÄ™ o wycenÄ™ wkĹ‚adu kominkowego DRAGON AKU 9 DUO w konfiguracji:\n\nModel: DRAGON AKU 9 DUO\nMoc: 25 kW\nKonfiguracjÄ…: [KONFIGURACJA]\nCena: [CENA] zĹ‚ netto\n\nUwaga: \n\nPozdrawiam'
    }
  }
}
